export default "__VITE_ASSET__CDfS8e9O__"